// extracted by mini-css-extract-plugin
export default {"lastRunInfo":"diagnostics_lastRunInfo__DGMcJ"};